import { GenderMessages } from "@/messages/gender/gender.messages";
import { SelectData } from "@/types/form.types";
import { GenderType } from "@/types/gender.types";

export const GENDERS_TRANSLATION = (messages: GenderMessages): Record<GenderType, string> => {
  return {
    [GenderType.Male]: messages.maleOption,
    [GenderType.Female]: messages.femaleOption,
    [GenderType.Unspecified]: messages.unspecifiedOption,
  };
};

export const GENDER_OPTIONS = (messages: GenderMessages): SelectData<GenderType | null>[] => {
  const labels = GENDERS_TRANSLATION(messages);
  return [
    { value: GenderType.Male, label: labels[GenderType.Male] },
    { value: GenderType.Female, label: labels[GenderType.Female] },
    { value: GenderType.Unspecified, label: labels[GenderType.Unspecified] },
    { value: null, label: messages.noneOption },
  ];
};
